// Components==============
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './File.module.scss';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
// =========================

export default function File({
  path,
  name,
  editMode,
}: {
  path: string;
  name: string;
  editMode?: boolean;
}) {
  return (
    <a
      href={path}
      download={name}
      styleName={`file ${editMode ? 'edit-mode' : ''}`}
    >
      {name}
      {!editMode && <FontAwesomeIcon icon={faChevronRight} />}
    </a>
  );
}
